enum RoutePath {
  Account = '/account',
  AccountVerification = '/account-verification',
  Admin = '/admin',
  AnalyticsSuite = '/analytics-suite',
  AdditionalInformationNeeded = '/additionalinformationneeded',
  AuthMethod = '/mixedmode',
  Book = '/book',
  BookMatch = '/book/find-your-match',
  BookPractitioners = '/book/practitioners',
  BookServices = '/book/services',
  BookService = '/book/services/:service',
  Chatbot = '/coach/chat',
  CheatSheet = '/cheat-sheet',
  CheckIn = '/checkin',
  CheckInConfirmation = '/checkinconfirmation',
  ConfirmSSOAccount = '/sso-confirm-account',
  Courses = '/courses',
  Dashboard = '/dashboard',
  EmailConfirmation = '/registration-confirmation',
  Explore = '/explore',
  ExplicitPrivacyConsentNeeded = '/explicitprivacyconsentneeded',
  ExternalPlayer = '/player',
  FindYourOrganisation = '/findteam',
  FindYourOrganisationConfirmation = '/teamemailconfirmation',
  ForgotPassword = '/forgotpassword',
  ForgotPasswordEmailConfirmation = '/emailconfirmation',
  Help = '/help',
  Home = '/home',
  InvalidInviteToken = '/signup/invalidinvitetoken',
  InviteColleague = '/account#invite-colleague',
  InviteFriend = '/account#invite-friend',
  InviteALovedOne = '/account#invite-a-loved-one',
  Login = '/',
  LoginWithCredentials = '/signin',
  LoginWithSSO = '/sso',
  MagicLogin = '/magicsignin',
  MagicLoginConfirmation = '/magicsigninconfirmation',
  Managers = '/managers',
  MSTeamsSSO = '/msteamssso',
  MSTeamsSSOCallback = '/msteamsssocallback',
  InviteesLimitReached = '/signup/tokenunavailable',
  PlusOneSignUp = '/plusonesignup',
  ResetPassword = '/reset',
  Series = '/series',
  Shorts = '/shorts',
  SignInToYourOrganisation = '/team',
  SignUp = '/signup',
  SignUpConfirmation = '/signupconfirmation',
  SignUpWorkDetails = '/signup/work-details',
  Sos = '/sos',
  SSOLoginHome = '/ssologinhome',
  SSOLoginSuccess = '/ssologinsuccess',
  SSOSignUp = '/sso-signup',
  SSOIdpInitatedLogin = '/sso-idp-login',
  StartSplitScreen = '/start',
  Tools = '/tools',
  Tool = '/tools/:category/:tool',
  ToolsList = '/tools/:category/',
  Track = '/track',
  UnmindIndex = '/unmindindex',
  VerifyAccountOwnership = '/verify-account-ownership',
  VerifyAccountOwnershipEmailConfirmation = '/verify-account-ownership-email-confirmation',
  Voice = '/voice',
  VoiceDisclaimer = '/voice/disclaimer',
  YourCourses = '/your-courses',
  Register = '/register',
}

export default RoutePath;
